import mitt from 'mitt';

import {
    on
} from 'delegated-events';
import SmoothScroll from 'smooth-scroll';
import validationService from './validationService';

const ADOPTIONTYPE_CLASS = '.js-adoption-type';
const ANIMAL_SELECTION_CLASS = '.js-animal-selection';
const smoothScroll = new SmoothScroll();

const DEFAULTS = {

};

class ParkAnimalAdoptionApi {
    constructor(container, {
        ...options
    } = {}) {
        this.options = { ...DEFAULTS, ...options };
        this.container = container;
        this.nodeId = container.dataset.nodeId;

        this.animalsContainer = container.querySelector('.js-animals-view');
        this.adoptionTypeContainer = container.querySelector('.js-adoption-type-view');
        this.additionalInfoContainer = container.querySelector('.js-additional-info-view');

        this.SelectedAdoptionTypeInput = container.querySelector('[name="AdoptionType"]');
        this.SelectedAnimalInput = container.querySelector('[name="SelectedAnimal"]');

        this.init = this.init.bind(this);
        this.emitter = mitt();
        this.on = this.emitter.on;
        this.off = this.emitter.off;

        this.setIdle = this.setIdle.bind(this);

        this.eventTypes = {
            adoptionTypeChanged: 'adoptionTypeChanged',
            animalSelectionChanged: 'animalSelectionChanged'
        };

        this.init(container);
    }

    setIdle(container) {
        if (container) {
            container.classList.remove('loading');
        }
    }

    init(container) {
        if (!container) {
            return;
        }

        on('click', ADOPTIONTYPE_CLASS, (e) => {
            this.handleAdoptionTypeClick(e);
        });
        on('change', ANIMAL_SELECTION_CLASS, (e) => {
            this.handleAnimalSelectionClick(e);
        });

        this.on(this.eventTypes.adoptionTypeChanged, (e) => {
            this.handleAdoptionTypeChanged(e);
        });

        this.handleAdoptionTypeClick = this.handleAdoptionTypeClick.bind(this);
        this.handleAnimalSelectionClick = this.handleAnimalSelectionClick.bind(this);

        this.handleAdoptionTypeChanged = this.handleAdoptionTypeChanged.bind(this);

        if (this.SelectedAnimalInput.value != '' && this.SelectedAdoptionTypeInput.value != '') {
            this.adoptionTypeContainer.style.display = "block";;
            this.additionalInfoContainer.style.display = "block";
            smoothScroll.animateScroll(
                document.getElementById('additional-info'),
                {
                    speed: 750,
                    easing: 'easeInOutQuad',
                }
            );
        } else if (this.SelectedAnimalInput.value != '') {
            this.adoptionTypeContainer.style.display = "block";;
            smoothScroll.animateScroll(
                document.getElementById('adoption-type'),
                {
                    speed: 750,
                    easing: 'easeInOutQuad',
                }
            );
       }
    }


    handleAdoptionTypeClick(e) {
        console.log('click handleAdoptionTypeClick');

        const { membershipName } = e.currentTarget.dataset;
        this.emitter.emit(this.eventTypes.adoptionTypeChanged, { membershipName })
    }

    handleAdoptionTypeChanged(e) {
        console.log(e);
        console.log('handleAdoptionTypeChanged', e);

        const { membershipName } = e;

        smoothScroll.animateScroll(
            document.getElementById('additional-info'),
            {
                speed: 750,
                easing: 'easeInOutQuad',
            }
        );

        this.setIdle(this.adoptionTypeContainer);

        this.SelectedAdoptionTypeInput.value = membershipName;
        this.additionalInfoContainer.style.display = "block";
    }

    handleAnimalSelectionClick(e) {
        console.log('click handleAnimalSelectionClick');

        const animalSelection = e.currentTarget.value;

        smoothScroll.animateScroll(
            document.getElementById('adoption-type'),
            {
                speed: 750,
                easing: 'easeInOutQuad',
            }
        );

        this.setIdle(this.additionalInfoContainer);

        this.SelectedAnimalInput.value = animalSelection;
        this.adoptionTypeContainer.style.display = "block";;
   }

    destroy() {
        this.off('*');
        this.emitter = null;
    }
}


export default ParkAnimalAdoptionApi;
